import { render, staticRenderFns } from "./carousel-posts-cmp.vue?vue&type=template&id=284a27bf&scoped=true"
import script from "./carousel-posts-cmp.vue?vue&type=script&lang=js"
export * from "./carousel-posts-cmp.vue?vue&type=script&lang=js"
import style0 from "./carousel-posts-cmp.vue?vue&type=style&index=0&id=284a27bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284a27bf",
  null
  
)

export default component.exports